import { useAppDispatch } from 'src/app/store/hooks';
import {
  TripTripTagRead,
  useTripTagsDestroyMutation,
} from 'src/common/external/bambi-api/bambiApi';
import { toastSlice } from 'src/common/primitives/Toast/toast.slice';
import { TagDisplay } from 'src/common/tags/TagDisplay/TagDisplay';

interface TripTagsDisplayProps {
  tags?: TripTripTagRead[] | null;
}

export default function TripTagsDisplay({
  tags,
}: TripTagsDisplayProps): JSX.Element | null {
  const dispatch = useAppDispatch();
  const [deleteTag] = useTripTagsDestroyMutation();

  return (
    <TagDisplay
      tags={tags}
      onDelete={(tagId) => {
        return deleteTag({
          id: tagId,
        })
          .unwrap()
          .catch(() => {
            dispatch(
              toastSlice.actions.show({
                title: 'Error deleting tag',
                type: 'error',
              })
            );
          });
      }}
    />
  );
}
